import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";

const tableHead = [
  "Sr.",
  "Employee Name",
  "Month & Year",
  "Month Performance",
  "Year Performance",
  "Action",
];

const ViewAllEEP = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/EEP/view/${id}`);
  };

  const returnClassnameBg = (monthlyPerformanceBand, rank) => {
  
    // ✅ Band-based color
    switch (monthlyPerformanceBand) {
      case "Top Performer":
        return { backgroundColor: "rgba(144, 238, 144, 0.3)" };
  
      case "Strong Performer":
        return { backgroundColor: "rgba(173, 216, 230, 0.3)" };
  
      case "Normal Performer":
        return { backgroundColor: "rgba(255, 255, 153, 0.3)" };
  
      case "Need Improvement":
        return { backgroundColor: "rgba(255, 182, 193, 0.3)" };
  
      case "Risk Employee":
        return { backgroundColor: "rgba(255, 99, 71, 0.3)" };
  
      default:
        break; // ✅ DO NOT return here
    }
  
    // ✅ Fallback: Rank-based color
    if (rank >= 1 && rank <= 3) {
      return { backgroundColor: "rgba(144, 238, 144, 0.25)" };
    } else if (rank >= 4 && rank <= 6) {
      return { backgroundColor: "rgba(255, 255, 153, 0.3)" };
    } else {
      return { backgroundColor: "rgba(255, 99, 71, 0.25)" };
    }
  };

  const rankedData = [];
let currentMonth = "";

let scoreRank = 0;
let percentRank = 0;
let Index = 1;

  const sortedData = (data?.allEepData || []).sort((a, b) => {
    // ✅ Step 1: Sort by Year
    if (a.eepYear !== b.eepYear) {
      return parseInt(b.eepYear) - parseInt(a.eepYear);
    }
  
    // ✅ Step 2: Sort by Month
    const monthOrder = {
      Jan: 1, Feb: 2, Mar: 3, Apr: 4,
      May: 5, Jun: 6, Jul: 7, Aug: 8,
      Sep: 9, Oct: 10, Nov: 11, Dec: 12,
    };
  
    if (a.eepMonth !== b.eepMonth) {
      return monthOrder[b.eepMonth] - monthOrder[a.eepMonth];
    }
  
    // ✅ Step 3: Inside same month → PRIORITY SORT
  
    const aHasScore = a.totalScoreFormulaScore && a.totalScoreFormulaScore !== "";
    const bHasScore = b.totalScoreFormulaScore && b.totalScoreFormulaScore !== "";
  
    const aHasPercent = a.finalScorePerMonthPercent && a.finalScorePerMonthPercent !== "";
    const bHasPercent = b.finalScorePerMonthPercent && b.finalScorePerMonthPercent !== "";
  
    // 🔥 PRIORITY 1 → totalScoreFormulaScore
    if (aHasScore && bHasScore) {
      return parseFloat(b.totalScoreFormulaScore) - parseFloat(a.totalScoreFormulaScore);
    }
  
    if (aHasScore) return -1; // a comes first
    if (bHasScore) return 1;  // b comes first
  
    // 🔥 PRIORITY 2 → finalScorePerMonthPercent
    if (aHasPercent && bHasPercent) {
      return parseFloat(b.finalScorePerMonthPercent) - parseFloat(a.finalScorePerMonthPercent);
    }
  
    if (aHasPercent) return -1;
    if (bHasPercent) return 1;
  
    return 0;
  });

  sortedData.forEach((item) => {
    const monthKey = `${item.eepMonth}-${item.eepYear}`;
  
    const isPercent =
      item.finalScorePerMonthPercent &&
      item.finalScorePerMonthPercent !== "";
  
    if (monthKey !== currentMonth) {
      currentMonth = monthKey;
      scoreRank = 0;
      percentRank = 0;
    }
  
    if (isPercent) {
      percentRank++;
      rankedData.push({
        ...item,
        rank: percentRank, // ✅ separate rank
        Index,
      });
    } else {
      scoreRank++;
      rankedData.push({
        ...item,
        rank: scoreRank, // ✅ separate rank
        Index,
      });
    }
  
    Index++;
  });

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {rankedData.map((item) => (
            <tr
              key={item.id}
              style={returnClassnameBg(item.monthlyPerformanceBand, item.rank)}
            >
              <td>{item.Index}</td>
              <td>{item?.employeeName}</td>
              <td>
                {item?.eepMonth} ({item?.eepYear})
              </td>
              <td>
                {item?.finalScorePerMonthPercent &&
                item.finalScorePerMonthPercent !== ""
                  ? `${item.finalScorePerMonthPercent} %`
                  : item?.totalScoreFormulaScore}
              </td>
              <td>
                {item?.finalScorePerYearPercent &&
                item.finalScorePerYearPercent !== ""
                  ? `${item.finalScorePerYearPercent} %`
                  : item?.totalYearScoreFormulaScore}
              </td>
              <td>
                <button
                  className="btn btn-sm px-3 btn-primary"
                  onClick={() => goToView(item.id)}
                >
                  <BsArrowRightShort className="me-1" /> View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewAllEEP;
